export const REACT_APP_BASE_BE_URL = `https://${window.location.host.split('.').shift()}.api.insent.ai`;
export const REACT_APP_BASE_FE_URL = `https://${window.location.host.split('.').shift()}.insent.ai/`
